import { Expose } from 'class-transformer';
import { IsEnum } from 'class-validator';

export enum CalloutVariant {
  Information = 'information', //blue callout
  Important = 'important', //yellow callout
  Emergency = 'emergency', //red callout
  Success = 'success', //green callout
}

export enum CalloutEmphasis {
  Low = 'low',
  Medium = 'medium',
  High = 'high',
}

export class CalloutContent {
  @Expose()
  @IsEnum(CalloutVariant) //enforce that calloutVariant needs to be fron the existing enum list
  calloutVariant?: CalloutVariant; //information | important | emergency | success
  @Expose()
  headerText?: string;
  @Expose()
  bodyText?: string;
  @Expose()
  emphasis?: CalloutEmphasis; //low | medium | high
  @Expose()
  outerTopContent?: string; //allows us to put content above callout. use for instances where content above the callout needs to stay with the callout
  @Expose()
  outerBottomContent?: string; //allows us to put content below callout. use for instances where content below the callout needs to stay with the callout
}

//used to handle a collection of callouts
export interface CalloutContentCollection {
  value?: CalloutContent; //this is the only property we need for display. By default set this to the 'default', but value will be transformed
  default?: CalloutContent;
  spousePartner?: CalloutContent;
  oboDefault?: CalloutContent;
  oboSpousePartner?: CalloutContent;
}
export type CalloutCollection = Record<string, CalloutContentCollection>;
